import { IconWrapper } from '../runtime';
export default IconWrapper('link', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.44199 8.0131C9.98786 9.13066 9.86033 10.4964 9.0594 11.498C8.98572 11.5901 8.90634 11.6792 8.82126 11.7647L7.05219 13.5426C5.78205 14.819 3.72274 14.819 2.4526 13.5426C1.18247 12.2661 1.18247 10.1966 2.4526 8.92016L3.897 7.46861M12.0616 8.57274L13.5474 7.07959C14.8175 5.80316 14.8175 3.73364 13.5474 2.45721C12.2773 1.18077 10.218 1.18077 8.94781 2.45721L7.17874 4.23505C5.95481 5.46505 5.91028 7.43147 7.04517 8.71505",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});